export enum LocationType {
  Unknown = 'Unknown',
  Location = 'Location',
  Room = 'Room',
}
